import { render, staticRenderFns } from "./Fouling.vue?vue&type=template&id=84d1b8c6&scoped=true&"
import script from "./Fouling.vue?vue&type=script&lang=ts&"
export * from "./Fouling.vue?vue&type=script&lang=ts&"
import style0 from "./Fouling.vue?vue&type=style&index=0&id=84d1b8c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1b8c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbar,VToolbarTitle})
